import { Box, Container, Typography, Button } from "@mui/material";
import enclosure from "../assets/en.png";
import tankImg from "../assets/tankimage.png";
import lathe from "../assets/lathe.png";
import strwork from "../assets/strwork.png";
const categories = [
  {
    title: "Structure Work",
    description: "Robust metal frameworks for industrial and engineering projects, including base frame of Burj Khalifa, platform work, and bridge structures.",
  },
  {
    title: "Machining Work",
    description: "Precision machining services including lathe work, shearing & bending, CNC bending, press machining, and laser/lesser cutting work.",
  },
  {
    title: "Tank Work",
    description: "Durable tanks for industrial use such as STP tanks, fuel tanks, water tanks, and day tanks.",
  },
  {
    title: "Enclosure Work",
    description: "High-performance enclosures for equipment protection, including acoustic enclosures and industrial equipment enclosures.",
  },
];

const categoryImage =[strwork,lathe,tankImg,enclosure]

export default function CoreProductCategories() {
  return (
    <Box sx={{ py: { xs: 6, md: 10 }, backgroundColor: "#f5f5f5" }}>
      <Container>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 900,
            mb: 6,
            textAlign: "center",
            color: "#1a237e",
            fontSize: {
              xs: "1.5rem",
              sm: "1.3rem",
              md: "2rem",
              lg: "2rem",
            },
          }}
        >
          Core Product Categories
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "flex-start",
            gap: 4,
          }}
        >
          {categories.map((cat, idx) => (
            <Box
              key={idx}
              sx={{
                width: { xs: "100%", sm: "45%", md: "22%" },
                borderRadius: 3,
                overflow: "hidden",
                background: "rgba(255,255,255,0.05)",
                backdropFilter: "blur(6px)",
                boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
                transition: "transform 0.3s, box-shadow 0.3s",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 12px 35px rgba(0,0,0,0.25)",
                },
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  height: 180,
                  overflow: "hidden",
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                  flexShrink: 0,
                }}
              >
                <img
                  src={categoryImage[idx]}
                  alt="Category"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderTopLeftRadius: "12px",
                    borderTopRightRadius: "12px",
                    display: "block",
                  }}
                />
              </Box>

              <Box sx={{ p: 3 }}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, mb: 1, color: "#1a237e" }}
                >
                  {cat.title}
                </Typography>
                <Typography variant="body2" sx={{ color: "#333" }}>
                  {cat.description}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
